// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3zTw9","savePackageButton":"ClientWallet_savePackageButton__1vl1z"};